import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "bg-white rounded-xl shadow-lg p-8" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-lg bg-red-50 p-3 text-red-600 text-sm text-center"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "text-sm text-gray-500 text-center mb-6" }
const _hoisted_8 = {
  key: 0,
  class: "rounded-lg bg-red-50 p-3 text-red-600 text-sm text-center"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "text-center text-xs text-gray-400" }
const _hoisted_11 = {
  key: 2,
  class: "text-center py-4"
}
const _hoisted_12 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_13 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_14 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "rounded-lg bg-red-50 p-3 text-red-600 text-sm text-center"
}
const _hoisted_20 = { class: "flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-3 pt-2" }
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = {
  key: 0,
  class: "rounded-lg bg-red-50 p-3 text-red-600 text-sm text-center"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "mt-6 text-center border-t border-gray-100 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['w-full transition-[max-width] duration-300', $setup.step === 4 ? 'max-w-2xl' : 'max-w-md'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "flex justify-center mb-8" }, [
          _createElementVNode("img", {
            src: "/logo-icon.webp",
            alt: "Optyfind",
            class: "h-20 w-auto"
          })
        ], -1)),
        ($setup.step === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 text-center mb-6" }, "Create your account", -1)),
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleInitiate && $setup.handleInitiate(...args)), ["prevent"])),
                class: "space-y-4"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", {
                      for: "register-first-name",
                      class: "block text-sm font-medium text-gray-700 mb-1"
                    }, "First name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "register-first-name",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.profile.first_name) = $event)),
                      type: "text",
                      autocomplete: "given-name",
                      maxlength: "100",
                      required: "",
                      placeholder: "Jane",
                      class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                    }, null, 512), [
                      [_vModelText, $setup.profile.first_name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", {
                      for: "register-last-name",
                      class: "block text-sm font-medium text-gray-700 mb-1"
                    }, "Last name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "register-last-name",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.profile.last_name) = $event)),
                      type: "text",
                      autocomplete: "family-name",
                      maxlength: "100",
                      required: "",
                      placeholder: "Smith",
                      class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                    }, null, 512), [
                      [_vModelText, $setup.profile.last_name]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Email address", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                      _createElementVNode("svg", {
                        class: "h-5 w-5 text-gray-400",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.email) = $event)),
                      type: "email",
                      autocomplete: "email",
                      required: "",
                      placeholder: "you@example.com",
                      class: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                    }, null, 512), [
                      [_vModelText, $setup.email]
                    ])
                  ])
                ]),
                ($setup.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.loading,
                  class: "w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 disabled:opacity-50 transition-colors"
                }, _toDisplayString($setup.loading ? 'Sending code...' : 'Continue'), 9, _hoisted_6),
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-center text-xs text-gray-400" }, "Free forever. No credit card required.", -1))
              ], 32)
            ], 64))
          : ($setup.step === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 text-center mb-2" }, "Check your email", -1)),
                _createElementVNode("p", _hoisted_7, [
                  _cache[26] || (_cache[26] = _createTextVNode(" We sent a 6-digit code to ")),
                  _createElementVNode("strong", null, _toDisplayString($setup.email), 1),
                  _cache[27] || (_cache[27] = _createTextVNode(". Enter it below. "))
                ]),
                _createElementVNode("form", {
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleVerify && $setup.handleVerify(...args)), ["prevent"])),
                  class: "space-y-4"
                }, [
                  _createElementVNode("div", null, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Verification code", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.code) = $event)),
                      type: "text",
                      inputmode: "numeric",
                      maxlength: "6",
                      required: "",
                      placeholder: "123456",
                      class: "block w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 text-center text-2xl font-mono tracking-widest placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                    }, null, 512), [
                      [_vModelText, $setup.code]
                    ])
                  ]),
                  ($setup.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.error), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: $setup.loading,
                    class: "w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 disabled:opacity-50 transition-colors"
                  }, _toDisplayString($setup.loading ? 'Verifying...' : 'Verify email'), 9, _hoisted_9),
                  _createElementVNode("p", _hoisted_10, [
                    _cache[29] || (_cache[29] = _createTextVNode(" Didn't get the email? ")),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleInitiate && $setup.handleInitiate(...args))),
                      class: "text-brand-600 hover:underline"
                    }, "Resend code")
                  ])
                ], 32)
              ], 64))
            : ($setup.step === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[31] || (_cache[31] = [
                  _createStaticVNode("<div class=\"mx-auto mb-4 flex items-center justify-center w-16 h-16 rounded-full bg-green-100\"><svg class=\"w-8 h-8 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 13l4 4L19 7\"></path></svg></div><h2 class=\"text-2xl font-bold text-gray-900 mb-2\">Email confirmed!</h2><p class=\"text-sm text-gray-500\">Setting up your account…</p>", 3)
                ])))
              : ($setup.step === 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"border-t-4 border-brand-600 pt-5\"><div class=\"flex items-start justify-between gap-4\"><div><p class=\"text-xs font-semibold uppercase tracking-wider text-brand-700 mb-2\">Optional setup</p><h2 class=\"text-2xl font-bold text-gray-900\">Set up application autofill</h2></div><span class=\"shrink-0 rounded-full border border-gray-300 px-3 py-1 text-xs font-medium text-gray-600\">Step 3 of 4</span></div><p class=\"mt-3 text-sm leading-6 text-gray-600\"> These details are stored in your Optyfind account and used by the browser extension to fill supported job applications in your browser. Review every application before submitting; Optyfind never submits one for you. </p><p class=\"mt-2 text-xs text-gray-500\">You can change or remove this information anytime in Settings.</p></div>", 1)),
                    _createElementVNode("form", {
                      onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleProfileContinue && $setup.handleProfileContinue(...args)), ["prevent"])),
                      class: "mt-6 space-y-4"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", {
                            for: "register-phone",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "Phone number", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "register-phone",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.profile.phone) = $event)),
                            type: "tel",
                            autocomplete: "tel",
                            maxlength: "40",
                            placeholder: "+1 416 555 0199",
                            class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                          }, null, 512), [
                            [_vModelText, $setup.profile.phone]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", {
                            for: "register-linkedin",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "LinkedIn profile", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "register-linkedin",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.profile.linkedin_url) = $event)),
                            type: "url",
                            autocomplete: "url",
                            maxlength: "500",
                            placeholder: "https://linkedin.com/in/your-name",
                            class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                          }, null, 512), [
                            [_vModelText, $setup.profile.linkedin_url]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", {
                          for: "register-address-1",
                          class: "block text-sm font-medium text-gray-700 mb-1"
                        }, "Street address", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "register-address-1",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.profile.address_line_1) = $event)),
                          type: "text",
                          autocomplete: "address-line1",
                          maxlength: "255",
                          class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                        }, null, 512), [
                          [_vModelText, $setup.profile.address_line_1]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", {
                          for: "register-address-2",
                          class: "block text-sm font-medium text-gray-700 mb-1"
                        }, "Apartment, suite, or unit", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "register-address-2",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.profile.address_line_2) = $event)),
                          type: "text",
                          autocomplete: "address-line2",
                          maxlength: "255",
                          class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                        }, null, 512), [
                          [_vModelText, $setup.profile.address_line_2]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", {
                            for: "register-city",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "City", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "register-city",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.profile.city) = $event)),
                            type: "text",
                            autocomplete: "address-level2",
                            maxlength: "100",
                            class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                          }, null, 512), [
                            [_vModelText, $setup.profile.city]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", {
                            for: "register-postal-code",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "Postal or ZIP code", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "register-postal-code",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.profile.postal_code) = $event)),
                            type: "text",
                            autocomplete: "postal-code",
                            maxlength: "30",
                            class: "block w-full px-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                          }, null, 512), [
                            [_vModelText, $setup.profile.postal_code]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _cache[39] || (_cache[39] = _createElementVNode("label", {
                            for: "register-country",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "Country", -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "register-country",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.profile.country_code) = $event)),
                            onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.onCountryChange && $setup.onCountryChange(...args))),
                            class: "block w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                          }, [
                            _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "Select country", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: country.code,
                                value: country.code
                              }, _toDisplayString(country.name), 9, _hoisted_15))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, $setup.profile.country_code]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[40] || (_cache[40] = _createElementVNode("label", {
                            for: "register-state",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, "Province or state", -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "register-state",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.profile.state_province_code) = $event)),
                            disabled: $setup.states.length === 0,
                            class: "block w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 disabled:bg-gray-100 disabled:text-gray-400 sm:text-sm"
                          }, [
                            _createElementVNode("option", _hoisted_17, _toDisplayString($setup.states.length ? 'Select province or state' : 'Select a country first'), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.states, (state) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: state.code,
                                value: state.code
                              }, _toDisplayString(state.name), 9, _hoisted_18))
                            }), 128))
                          ], 8, _hoisted_16), [
                            [_vModelSelect, $setup.profile.state_province_code]
                          ])
                        ])
                      ]),
                      ($setup.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.error), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($setup.skipProfile && $setup.skipProfile(...args))),
                          class: "text-sm font-medium text-gray-600 hover:text-gray-900 underline underline-offset-4"
                        }, " Skip for now "),
                        _cache[41] || (_cache[41] = _createElementVNode("button", {
                          type: "submit",
                          class: "flex justify-center py-2.5 px-6 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 transition-colors"
                        }, " Continue ", -1))
                      ])
                    ], 32)
                  ], 64))
                : ($setup.step === 5)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "flex items-start justify-between gap-4 mb-6" }, [
                        _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900" }, "Create a password"),
                        _createElementVNode("span", { class: "shrink-0 rounded-full border border-gray-300 px-3 py-1 text-xs font-medium text-gray-600" }, "Step 4 of 4")
                      ], -1)),
                      _createElementVNode("form", {
                        onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleComplete && $setup.handleComplete(...args)), ["prevent"])),
                        class: "space-y-4"
                      }, [
                        _createElementVNode("div", null, [
                          _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Password", -1)),
                          _createElementVNode("div", _hoisted_21, [
                            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                              _createElementVNode("svg", {
                                class: "h-5 w-5 text-gray-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                })
                              ])
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.password) = $event)),
                              type: "password",
                              autocomplete: "new-password",
                              required: "",
                              placeholder: "At least 8 characters",
                              class: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
                            }, null, 512), [
                              [_vModelText, $setup.password]
                            ])
                          ])
                        ]),
                        ($setup.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.error), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "submit",
                          disabled: $setup.loading,
                          class: "w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 disabled:opacity-50 transition-colors"
                        }, _toDisplayString($setup.loading ? 'Creating account...' : 'Create account'), 9, _hoisted_23)
                      ], 32)
                    ], 64))
                  : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: "/login",
            class: "text-sm font-medium text-brand-600 hover:text-brand-500"
          }, {
            default: _withCtx(() => _cache[46] || (_cache[46] = [
              _createTextVNode(" Already have an account? Sign in ")
            ])),
            _: 1
          })
        ])
      ])
    ], 2)
  ]))
}